<template>
  <b-button :variant="variant" :disabled="saveButtonState !== ''" type="submit">
    <fa-icon v-if="saveButtonState === 'saving'" :icon="['fad', 'spinner-third']" :spin="true" class="mr-1" />
    <fa-icon v-if="saveButtonState === 'done'" :icon="['fas', 'check']" class="mr-1" />
    <fa-icon v-if="saveButtonState === 'error'" :icon="['fas', 'times']" class="mr-1" />
    {{text}}
  </b-button>
</template>

<script>
export default {
  name: 'SaveButtonComponent',
  props: {
    saveButtonState: String
  },
  computed: {
    variant: function() {
      if (this.saveButtonState === 'saving') {
        return 'primary'
      } else if (this.saveButtonState === 'done') {
        return 'success'
      } else if (this.saveButtonState === 'error') {
        return 'danger'
      } else {
        return 'primary'
      }
    },
    text: function() {
      if (this.saveButtonState === 'saving') {
        return 'Bitte warten'
      } else if (this.saveButtonState === 'done') {
        return 'Erledigt'
      } else if (this.saveButtonState === 'error') {
        return 'Fehler'
      } else {
        return 'Speichern'
      }
    }
  }
}
</script>